module.exports = __webpack_public_path__ + "static/media/table.cd4f15eb.svg";